import axiosInstance from './axiosInstance';

const BASE = (pid) => `/plants/${pid}/raw-materials`;

export const getAllRawMaterials = async (pid, params) => {
  return await axiosInstance.get(BASE(pid), { params });
};

export const createRawMaterial = async (pid, data) => {
  return await axiosInstance.post(BASE(pid), data);
};

export const updateRawMaterial = async (pid, rawId, data) => {
  return await axiosInstance.put(`${BASE(pid)}/${rawId}`, data);
};

export const deleteRawMaterial = async (pid, rawId) => {
  return await axiosInstance.delete(`${BASE(pid)}/${rawId}`);
};

export const getStock = async (pid, rawId) => {
  return await axiosInstance.get(`${BASE(pid)}/${rawId}/stock`);
};